import React from 'react';
import {Link} from 'react-router-dom';
import './Card.css';

const Card = (props) => (
  <div className="col-sm-3 fade-in card-publicaciones">
    <div className="single-blog-margin">
      <figure>
        <Link to={{ pathname: `/publicacion/${props.id}`, state: { props } }}>
          <div className="blog-thumb">
            <img src={props.image} alt={props.title} title={props.title} className="width-100 img-responsive" style={{maxHeight:"190px"}}/>
  				</div>
          <figcaption>
          <h3 className="" title={props.title}>{props.title}</h3>
          <p className="author" title={props.autor}>by <span>{props.autor}</span></p>
          </figcaption>
        </Link>
      </figure>
    </div>
	</div>
);

export default Card;
